'use client'
import React from 'react'
import Link from 'next/link'
import { TypewriterEffectSmooth } from '@/components/typewriter-effect'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/registry/default/ui/button'
import { Icons } from '@/components/icons'
import { useSession } from 'next-auth/react'
import Image from 'next/image'

interface BentoSectionProps {}

export function BentoSection({}: BentoSectionProps) {
  const wordOnes = [
    {
      text: '由AI驱动的呼叫中心业务',
    },
  ]
  const wordTwos = [
    {
      text: '洞察用户需求，智能派单质检',
      className: 'text-primary dark:text-primary',
    },
  ]
  const { status } = useSession()
  return (
    <div className="container px-0 relative">
      <div className="md:h-[40rem] px-4 xl:h-[45rem] 2xl:h-[60rem] h-full w-full  dark:bg-grid-small-white/[0.3] bg-grid-small-black/[0.3] relative flex items-center justify-center ">
        <div className="absolute pointer-events-none inset-0 flex items-center justify-center  dark:bg-background bg-background [mask-image:radial-gradient(ellipse_at_center,transparent_60%,black)]"></div>
        <div className="grid w-full md:flex md:justify-between ">
          <div className="flex flex-col w-full md:w-[50%] items-center md:items-start justify-center md:h-[30rem] xl:h-[40rem] h-[24rem] space-y-4 md:px-0">
            <TypewriterEffectSmooth words={wordOnes} hiddenCursor={true} />
            <TypewriterEffectSmooth words={wordTwos} />
            <p className="text-xl md:text-xl mb-4 md:px-1 font-medium">
              AI 全流程自动化交付，让您极大减少用工，达成远超过去的业务增长。
            </p>
            <div className="flex items-center justify-center md:justify-start w-full space-x-4">
              <Link
                passHref
                rel="noreferrer"
                target="_blank"
                href={
                  status === 'authenticated'
                    ? `/answer`
                    : { pathname: `/login`, query: { role: 'expert' } }
                }
                className={cn(buttonVariants({variant:'default', size: 'lg' }))}
              >
                <Icons.tailwind className="mr-2 h-4 w-4" />
                申请试用
              </Link>
            </div>
          </div>
          <div className="w-full md:w-[50%] flex flex-col gap-8">
            <div className={'w-full flex justify-between'}>
              <div className={'flex h-full rounded-xl items-center justify-center'}>
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md justify-center font-medium flex w-full h-full  ">
                    成本下降
                  </h6>
                  <h2 className="text-3xl justify-center flex md:text-3xl w-full h-full">85%</h2>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/cb.svg'}
                      width={160}
                      height={160}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
              <div className=" flex h-full items-center justify-center overflow-hidden rounded-xl ">
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md justify-center font-medium flex w-full h-full  ">
                    产出提升
                  </h6>
                  <h2 className="text-3xl justify-center flex md:text-3xl font-medium w-full h-full ">
                    300%
                  </h2>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/cc.svg'}
                      width={160}
                      height={160}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
              <div className=" flex h-full items-center justify-center overflow-hidden rounded-xl ">
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md justify-center  font-medium flex w-full h-full  ">
                    风险降低
                  </h6>
                  <h2 className="text-3xl md:text-3xl flex justify-center font-medium w-full h-full ">
                    95%
                  </h2>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/fx.svg'}
                      width={160}
                      height={160}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={'w-full'}>
              <Image
                alt={'design'}
                src={'/home/line.svg'}
                width={460}
                height={160}
                className={cn('w-full object-cover')}
              />
            </div>
            <div className={'w-full flex justify-between'}>
              <div className=" flex h-full items-center justify-center overflow-hidden rounded-xl ">
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md text-center justify-center text-blue-600 font-medium flex w-full h-full  ">
                    数据
                  </h6>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/data.svg'}
                      width={180}
                      height={180}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
              <div className=" flex h-full items-center justify-center overflow-hidden rounded-xl ">
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md justify-center font-medium flex w-full h-full  ">
                    AI员工调度
                  </h6>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/dd.svg'}
                      width={180}
                      height={180}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
              <div className=" flex h-full items-center justify-center overflow-hidden rounded-xl ">
                <div className=" flex flex-col items-center gap-4 w-full">
                  <h6 className="text-md justify-center text-blue-600 font-medium flex w-full h-full  ">
                    工作流
                  </h6>
                  <div className={'flex'}>
                    <Image
                      alt={'design'}
                      src={'/home/flow.svg'}
                      width={160}
                      height={160}
                      className={cn('object-cover')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
